<template>
  <div class="msg-details site-wrapper">
    <div class="guide">
      <span>您的位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }"> 首页 </el-breadcrumb-item>
        <el-breadcrumb-item>账号管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="info" style="margin-top: 10px;">
      <el-table v-loading="tableLoading" class="content_table" :data="tableData" style="width: 1168px;margin:  0 auto;">
        <el-table-column :label="item.label" align="center" v-for="(item, index) of tHeader" :key="index">
          <el-table-column :prop="item.post" show-overflow-tooltip align="center" :width="item.width">
            <template slot="header" slot-scope="{}">
              <span v-if="item.type === 'input'">
                <el-input v-model="searchForm[item.post]" size="mini" clearable prefix-icon="el-icon-search" @clear="pageIndex = 1; getDataList()" @blur="pageIndex = 1; getDataList()" placeholder="请输入" />
              </span>
              <span slot="header" v-if="item.type === 'select'">
                <el-select v-model="searchForm[item.spost]" size="mini" clearable prefix-icon="el-icon-search" @clear="pageIndex = 1; getDataList()" @change="pageIndex = 1; getDataList()" placeholder="请选择">
                  <el-option :label="op.label" :value="op.code" v-for="(op, i) of item.options" :key="i"></el-option>
                </el-select>
              </span>
              <span slot="header" v-if="item.type === 'date'">
                <el-date-picker value-format="yyyy-MM-dd 00:00:00" @change="pageIndex = 1; getDataList()" type="date" format="yyyy-MM-dd" placeholder="选择日期" v-model="searchForm[item.post]" style="width: 100%"></el-date-picker>
              </span>
            </template>
            <template slot-scope="scope">
              <span :style="{ color: textColor(item.post,scope.row.st)}">
                {{ item.post == 'st' ? (scope.row[item.post] == 1 ? '已完成' : scope.row[item.post] == 2 ? "待审核" : '/') : scope.row[item.post] || '/' }}
              </span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column fixed="right" header-align="center" align="center" width="110" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="examineOne(scope.row)" v-if="scope.row.st == 2">审核</el-button>
            <el-divider v-if="scope.row.st =='2'" direction="vertical"></el-divider>
            <el-button type="text" @click="seeOne(scope.row)">查看</el-button>
            <el-divider v-if="scope.row.st =='1'" direction="vertical"></el-divider>
            <el-button type="text" v-if="scope.row.st =='1'" style="color: #FF6F77;" @click="delOne(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mod-page">
        <pagination layout="prev, pager, next" v-show="totalPage > 0" :total="totalPage" :page.sync="pageIndex" :limit.sync="pageLimt" @pagination="getDataList" />
      </div>
    </div>
    <account-pop ref="accountPop"></account-pop>
  </div>
</template>
  
<script>
import { dateFtt } from "@/utils";
import Pagination from "@/components/Pagination";
import accountPop from "./accountPop.vue"
export default {
  components: {
    Pagination,
    accountPop
},
  data() {
    return {
      tableLoading: false,
      tableData: [],
      totalPage: 0,
      pageIndex: 1,
      pageLimt: 10,
      tHeader: [
        {
          label: "用户名",
          post: "name",
          type: "input"
        },
        {
          label: "手机号",
          post: "phone",
          type: "input"
        },
        {
          label: "申请时间",
          post: "createTime",
          width:160,
          type: "date"
        },
        {
          label: "QQ号",
          post: "qq",
          type: "input"
        },
        {
          label: "微信号",
          post: "wx",
          type: "input"
        },
        {
          label: "状态",
          post: "st",
          type: "select",
          spost: "st",//下拉框传参
          options: [
            {
              label: "待审核",
              code: 2
            },
            {
              label: "已完成",
              code: 1
            }
          ]
        },
        {
          label: "审核时间",
          post: "auditTime",
          width:160,
          type: "date"
        },
      ],
      searchForm: {},
      visible: false,
      detail:{}
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    delOne(item) {
				this.$confirm(`确定进行["删除"]操作?`, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					let param = {
						ids:[item.id]
					}
					this.$http.post(this.$api.shiroApi.cancelReveal, param).then(data => {
						this.$message({
							message: data.msg,
							type: "success"
						});
						this.getDataList();
					});
				});
			},
    textColor(prop,st) {
      if(prop == 'st' && st == 2){
        return '#1460AE';
      }
    },
    examineOne(row) {
      this.$refs.accountPop.visible = true;
      this.$refs.accountPop.personId = row.id;
    },
    seeOne(row) {
      this.$router.push({ name: 'userInfo' ,query: { id: row.id}});
    },
    getDataList() {
      this.tableLoading = true;
      let params = {
        current: this.pageIndex,
        size: this.pageLimt,
        data: this.searchForm
      }
      this.$http.post(this.$api.shiroApi.userList, params).then(({ data }) => {
        this.tableLoading = false;
        data.data.list.forEach(v => {
          if (v.addTime) {
            v.addTime = dateFtt(new Date(v.addTime), 1);
          }
        })
        this.tableData = data.data.list;
        this.totalPage = data.data.total;
      }).catch(() => {
        this.tableLoading = false;
      });
    }
  }
};
</script>
  
<style lang="scss" scoped>
.msg-details {
  position: relative;

  .guide {
    display: flex;
    margin-bottom: 0;
  }

  .info {
    min-height: 703px;
    padding-top: 16px;
    background: #fff;
    border-radius: 16px;
    margin-bottom: 56px;
  }

  .add {
    margin-bottom: 10px;
    text-align: right;

    button {
      padding: 8px 25px;
      font-size: 14px;
    }
  }

  .el-table .el-button {
    padding: 0;
  }
}
</style>
  